module.exports = __webpack_public_path__ + "static/media/groomingPageQualityIcon.d957f05f.png";